/**
 * Recommendations (owner rules, 2026-10-24) — cart drawer upsell (sections/cart-upsell.liquid) and
 * "Vous aimerez aussi" under the product page (sections/related-products.liquid).
 *
 * Pool (owner, 25 Oct 2026): the sub-collections of the audience (SUBS below), each fetched after the page and kept
 * 10 min in sessionStorage: <locale root>collections/<sub>?sort_by=created-descending&filter.v.availability=1
 * &section_id=bombas-reco-pool (sections/bombas-reco-pool.liquid: its 30 newest products whose stock is tracked and
 * in stock). The sub-collections are manual: a new product shows here once it is in its sub-collection.
 * Audience of a product: product metafield custom.audience, else assets/bombas-audience.js (computed from the
 * French handle / type), else the custom.audience of its collections.
 *
 * Choice:
 * 1. same audience only: homme → homme + mixte · femme → femme + mixte · mixte → mixte + homme + femme ·
 *    fille → fille + enfant (unisex kids) · garçon → garçon + enfant · enfant → all kids · bébé → bébé + enfant.
 *    Kids never get adult products and adults never get kids products.
 * 2. never the current product nor a product already in the cart (its sub-collection still counts).
 * 3. in each sub-collection, newest first, with: for shoes and kids the customer's size first (always, even before
 *    products with more stock), then good stock first (3+ sizes in stock, 5+ pieces for a one-size product). Sizes are only compared within the same size system:
 *    shoes (numeric: 27, 36, 43) with shoes, clothing (S / M / XL, 2A / 4A…) with clothing; another size system or no
 *    size (one size) isn't pushed down.
 * 4. round-robin: the 1st of each sub-collection, then the 2nd of each (2 per sub-collection), sub-collections
 *    ordered by their newest product. A product in two sub-collections shows once. Up to 12 cards (horizontal
 *    scroll; 8 in the desktop cart panel). Fewer than 4: more of each sub-collection, in the same order.
 */
(function () {
  'use strict';
  if (window.BBReco) return;

  var TTL = 10 * 60 * 1000;
  var CODES = { homme: 'h', femme: 'f', mixte: 'm', fille: 'F', garcon: 'G', enfant: 'E', bebe: 'B', enfants: 'E' };
  var COMPAT = { h: 'hm', f: 'fm', m: 'mhf', F: 'FE', G: 'GE', E: 'EFGB', B: 'BE' };
  var MAX = 12;
  var MIN = 4;
  var PER_SUB = 2;
  // Sub-collections per audience (owner, 25 Oct 2026).
  var SUBS = {
    h: ['sneakers-pour-homme', 'pantoufles-pour-homme', 'pyjama-pour-homme', 'peignoir-pour-homme', 'sandales-homme'],
    f: ['baskets-sneakers-pour-femme', 'chaussures-femme', 'bottes-bottines-pour-femme', 'pantoufles-pour-femme', 'pyjamas-pour-femmes', 'sandales-femme'],
    k: ['baskets-sneakers-enfants', 'bottes-bottines-pour-enfants', 'mocassins-enfants', 'pantoufles-pour-enfants', 'pyjamas-pour-enfants', 'sandales-pour-enfants']
  };

  function subsFor(aud) {
    if (aud === 'h') return SUBS.h;
    if (aud === 'f') return SUBS.f;
    if (aud === 'm') return SUBS.h.concat(SUBS.f);
    return 'FGEB'.indexOf(aud) > -1 && aud ? SUBS.k : [];
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function loadScript(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = s.onerror = function () {
        resolve();
      };
      document.head.appendChild(s);
    });
  }

  var audMap = null;
  function audienceMap(src) {
    if (audMap) return audMap;
    audMap = (window.bbAudience ? Promise.resolve() : loadScript(src)).then(function () {
      var m = { aud: {}, cat: {} };
      var a = window.bbAudience || {};
      var k = window.bbCategory || {};
      Object.keys(a).forEach(function (code) {
        a[code].forEach(function (id) {
          m.aud[id] = code;
        });
      });
      Object.keys(k).forEach(function (c) {
        k[c].forEach(function (id) {
          m.cat[id] = c;
        });
      });
      return m;
    });
    return audMap;
  }

  function fetchSub(sub) {
    var url = root() + 'collections/' + sub + '?sort_by=created-descending&filter.v.availability=1&section_id=bombas-reco-pool';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.text();
      })
      .then(function (h) {
        var m = h.match(/data-bb-reco-pool>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : { items: [], pages: 1, origin: '' };
      });
  }

  var pools = {};
  function pool(sub) {
    var key = 'bbRecoSub:' + root() + ':' + sub;
    if (pools[key]) return pools[key];
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.at < TTL) return (pools[key] = Promise.resolve(c.data));
    } catch (e) {}
    pools[key] = fetchSub(sub).then(function (data) {
      try {
        sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data: data }));
      } catch (e) {}
      return data;
    });
    // A missing / failing sub-collection never blocks the others.
    pools[key] = pools[key].catch(function () {
      delete pools[key];
      return { items: [], origin: '' };
    });
    return pools[key];
  }

  function audOf(item, map) {
    if (item.a && CODES[item.a]) return CODES[item.a];
    if (map.aud[item.id]) return map.aud[item.id];
    return caAud(item.ca);
  }

  // Size system: 'n' shoes (numeric sizes), 'c' clothing (S / M / XL, 2A…).
  function sizeSys(v) {
    return /^\d+([.,]\d+)?$/.test(String(v || '').trim()) ? 'n' : 'c';
  }

  function newest(a, b) {
    return (b.c || 0) - (a.c || 0);
  }

  /* lists: one item list per sub-collection; src: { aud (code), size, exclude: {id: true} } → items, best first. */
  function rank(lists, map, src, max) {
    var ok = COMPAT[src.aud] || '';
    var useSize = !!src.size && (/^\d+([.,]\d+)?$/.test(src.size) || 'FGEB'.indexOf(src.aud) > -1);
    var srcSys = sizeSys(src.size);
    var cols = lists
      .map(function (items) {
        return items
          .filter(function (it) {
            var a = audOf(it, map);
            return !src.exclude[it.id] && a && ok.indexOf(a) > -1;
          })
          .map(function (it) {
            var down = useSize && it.z && it.s.length && sizeSys(it.s[0]) === srcSys && it.s.indexOf(src.size) < 0;
            // Size first (owner, 25 Oct 2026): with the size before without it, even with more stock; stock breaks ties.
            return { it: it, t: (down ? 2 : 0) + (it.g ? 0 : 1) };
          })
          .sort(function (x, y) {
            return x.t - y.t || newest(x.it, y.it);
          })
          .map(function (x) {
            return x.it;
          });
      })
      .filter(function (c) {
        return c.length;
      });
    // Sub-collections ordered by their newest product.
    var top = function (c) {
      return Math.max.apply(null, c.map(function (it) { return it.c || 0; }));
    };
    cols.sort(function (x, y) {
      return top(y) - top(x);
    });
    var out = [];
    var seen = {};
    var pos = cols.map(function () { return 0; });
    // Rounds: 1st of each, 2nd of each… up to PER_SUB each; past that only while fewer than MIN.
    for (var round = 0; out.length < max; round++) {
      var any = false;
      for (var i = 0; i < cols.length && out.length < max; i++) {
        if (round >= PER_SUB && out.length >= MIN) break;
        while (pos[i] < cols[i].length && seen[cols[i][pos[i]].id]) pos[i]++;
        if (pos[i] >= cols[i].length) continue;
        var it = cols[i][pos[i]++];
        seen[it.id] = true;
        out.push(it);
        any = true;
      }
      if (!any || (round + 1 >= PER_SUB && out.length >= MIN)) break;
    }
    return out;
  }

  function pick(src, max) {
    return audienceMap(src.audSrc).then(function (map) {
      if (!src.aud) src.aud = (src.id && map.aud[src.id]) || src.caAud || '';
      var subs = subsFor(src.aud);
      if (!subs.length) return { data: { origin: '' }, items: [] };
      return Promise.all(subs.map(pool)).then(function (datas) {
        var origin = '';
        datas.forEach(function (d) {
          origin = origin || d.origin || '';
        });
        return {
          data: { origin: origin },
          items: rank(
            datas.map(function (d) {
              return d.items || [];
            }),
            map,
            src,
            max || MAX
          )
        };
      });
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cleanUrl(u) {
    return String(u || '').split('?')[0];
  }

  function cduCard(it, o) {
    var off = o.offer && it.e;
    var url = esc(cleanUrl(it.u));
    var h = '<div class="cdu-card"><a href="' + url + '" class="cdu-img">';
    if (it.i) h += '<img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" width="180" height="180" loading="lazy">';
    if (off) h += '<span class="cdu-badge">' + esc(o.badge) + '</span>';
    h += '</a><a href="' + url + '" class="cdu-name">' + esc(it.t) + '</a><div class="cdu-price">';
    h += off && it.pd ? '<s>' + esc(it.p) + '</s><span class="cdu-new">' + esc(it.pd) + '</span>' : esc(it.p);
    h += '</div>';
    if (off) h += '<div class="cdu-hint">' + esc(o.hint) + '</div>';
    if (it.d) {
      h += '<button type="button" class="cdu-add" data-cdu-add="' + it.d + '">' + esc(o.add) + '</button>';
    } else {
      h += '<div class="cdu-pick">' + esc(o.pick) + '</div><div class="cdu-sizes">';
      it.v.forEach(function (v) {
        h +=
          '<button type="button" class="cdu-size" data-cdu-add="' + v[0] + '" aria-label="' + esc(o.add + ' ' + it.t + ' – ' + v[1]) + '">' + esc(v[1]) + '</button>';
      });
      h += '</div>';
    }
    return h + '<div class="cdu-err" role="alert"></div></div>';
  }

  function vrCard(it, o, origin) {
    var url = cleanUrl(it.u).replace(/'/g, '%27');
    var h = '<div class="vr-card" data-pid="' + it.id + '" onclick="window.location.href=\'' + esc(url) + '\'"><div class="vr-card-img">' + (origin || '');
    if (it.i) h += '<img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" width="600" height="600" loading="lazy">';
    h += '</div><div class="vr-card-body"><div class="vr-card-name">' + esc(it.t) + '</div><div class="vr-card-prices"><span class="vr-card-price">' + esc(it.p) + '</span>';
    if (it.pc) h += '<span class="vr-card-old">' + esc(it.pc) + '</span>';
    h += '</div>';
    if (!it.d && it.vp.length) {
      h += '<div class="vr-card-sizes">';
      it.vp.forEach(function (v) {
        h += '<span class="vr-sz-pill' + (v[1] ? '' : ' out') + '">' + esc(v[0]) + '</span>';
      });
      h += '</div>';
    }
    return h + '<button type="button" class="vr-card-btn">' + esc(o.add) + '</button></div></div>';
  }

  // Audience from the product's collections (custom.audience), when nothing else is known.
  function caAud(ca) {
    var l = String(ca || '').split(' ').filter(Boolean);
    if (l.indexOf('enfants') > -1) return 'E';
    return l.length === 1 ? CODES[l[0]] || '' : '';
  }

  function ids(str) {
    var m = {};
    String(str || '')
      .split(',')
      .forEach(function (x) {
        if (x) m[x] = true;
      });
    return m;
  }

  /* Cart drawer: el = .cdu (data-* from cart-upsell.liquid). Resolves with the number of cards. */
  function fillCart(el) {
    var d = el.dataset;
    var src = { id: d.srcId, aud: CODES[d.aud] || '', caAud: caAud(d.ca), type: d.type || '', size: d.size || '', exclude: ids(d.incart), audSrc: d.audSrc };
    // Phone: horizontal strip (up to 12); desktop: side panel (8).
    var max = window.matchMedia && window.matchMedia('(min-width: 750px)').matches ? 8 : MAX;
    return pick(src, max).then(function (r) {
      var list = el.querySelector('.cdu-list');
      if (!list) return 0;
      var o = { offer: d.offer === 'true', badge: d.badge, hint: d.hint, add: d.add, pick: d.pick };
      list.innerHTML = r.items.map(function (it) {
        return cduCard(it, o);
      }).join('');
      return r.items.length;
    });
  }

  /* Product page: el = [data-bb-reco="vr"] (sections/related-products.liquid). */
  function currentSize(el) {
    var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var vid = (form && form.value) || new URLSearchParams(location.search).get('variant') || '';
    var map = {};
    try {
      map = JSON.parse(el.getAttribute('data-variant-sizes') || '{}');
    } catch (e) {}
    return (vid && map[vid]) || el.getAttribute('data-size') || '';
  }

  function fillProduct(el) {
    var d = el.dataset;
    var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    var size = currentSize(el);
    if (el.__bbSize === size && el.__bbDone) return Promise.resolve();
    el.__bbSize = size;
    return fetch(cartUrl, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return { items: [] };
      })
      .then(function (cart) {
        var ex = {};
        ex[d.pid] = true;
        (cart.items || []).forEach(function (i) {
          ex[i.product_id] = true;
        });
        var src = { id: d.pid, aud: CODES[d.aud] || '', caAud: caAud(d.ca), type: d.type || '', size: size, exclude: ex, audSrc: d.audSrc };
        return pick(src);
      })
      .then(function (r) {
        var track = el.querySelector('.vr-track');
        if (!r.items.length) {
          el.closest('.bb-reco-wrap').hidden = true;
          return;
        }
        track.style.transform = '';
        window.vrIndex = 0;
        track.innerHTML = r.items.map(function (it) {
          return vrCard(it, { add: d.add }, r.data.origin);
        }).join('');
        el.classList.add('is-ready');
        el.__bbDone = true;
      });
  }

  function initProduct() {
    var el = document.querySelector('[data-bb-reco="vr"]');
    if (!el) return;
    var go = function () {
      fillProduct(el).catch(function (e) {
        console.error('[reco]', e);
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (en) {
          if (en.some(function (x) { return x.isIntersecting; })) {
            io.disconnect();
            go();
          }
        },
        { rootMargin: '900px 0px' }
      );
      io.observe(el);
    } else {
      go();
    }
    // Size chosen on the product page → products with that size in stock first.
    document.addEventListener('change', function (e) {
      if (el.__bbDone && e.target.closest && e.target.closest('form[action*="/cart/add"], .product-form, [id^="product-form"]')) setTimeout(go, 50);
    });
    document.addEventListener('click', function (e) {
      if (!el.__bbDone || !e.target.closest) return;
      if (e.target.closest('main') && !e.target.closest('[data-bb-reco]')) setTimeout(go, 120);
    });
  }

  window.BBReco = { fillCart: fillCart, fillProduct: fillProduct, rank: rank };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProduct);
  else initProduct();
})();
